import { useMutation, useQueryClient } from '@tanstack/react-query'
import { putOrganizationInterop } from '../../../../data/admin'
import { OrganizationInterop } from '../../../../model/OrganizationInterop'
import { addValid } from '../../../../store/message'
import { useActionDispatch } from '../../../utils'
import { organizationInteropKeys } from './organizationInterop.keys'
import { InteropUserFriendlyError, mapInteropApiErrorToUi } from './organizationInteropError.mapper'

interface PutOrganizationInteropMutateVariables {
  organizationCode: string
  variables: Partial<OrganizationInterop>
}

export const usePutOrganizationInterop = () => {
  const valid = useActionDispatch(addValid)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ organizationCode, variables }: PutOrganizationInteropMutateVariables) => {
      const apiResponse = await putOrganizationInterop(organizationCode, variables)
      const { data, ok } = apiResponse

      if (!data || !ok) {
        throw new InteropUserFriendlyError(mapInteropApiErrorToUi(apiResponse))
      }

      return data
    },

    onSuccess: (organization) => {
      valid('Organisation interop mise à jour')
      queryClient.refetchQueries({ queryKey: organizationInteropKeys.lists })
      queryClient.setQueryData(organizationInteropKeys.detail(organization.code), organization)
    },
  })
}
